import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as faqSanityApi from 'api/sanity/faq';
import { getI18n } from 'react-i18next';
import { AppThunk } from 'store';

const toFaq = (sanityFaq: SanityFAQ): FAQ => {
  const lang = getI18n().language as Language;
  return {
    question: sanityFaq.faqQuestion.textContent[lang] ? sanityFaq.faqQuestion.textContent[lang] : sanityFaq.faqQuestion.textContent['en'],
    answer: sanityFaq.faqAnswer.textContent[lang] ? sanityFaq.faqAnswer.textContent[lang] : sanityFaq.faqAnswer.textContent['en'],
  };
};

interface State {
  loading: boolean;
  items: FAQ[];
}

const initialState: State = {
  loading: false,
  items: [],
};

const slice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    setFaqs: (state: State, action: PayloadAction<FAQ[]>): State => {
      state.items = action.payload;
      return state;
    },
    setLoading: (state: State, action: PayloadAction<boolean>): State => {
      state.loading = action.payload;
      return state;
    },
  },
});
const { setLoading, setFaqs } = slice.actions;
export default slice.reducer;

export const loadFaqs = (page: string, partnerPage?: string): AppThunk => async (dispatch): Promise<void> => {
  dispatch(setLoading(true));
  try {
    let data;
    if (partnerPage) {
      const collection = await faqSanityApi.getFaqsForPages(page, partnerPage);
      const partnerIndex = collection.findIndex(item => partnerPage.includes(item.slug.current));
      if (partnerIndex !== -1) {
        data = collection[partnerIndex]?.faqs ?? [];
      } else {
        data = collection[0]?.faqs ?? [];
      }
    } else {
      data = await faqSanityApi.getFaqsFor(page);
    }
    const faqs = data.map(toFaq);
    dispatch(setFaqs(faqs));
    dispatch(setLoading(false));
  } catch {
    dispatch(setLoading(false));
  }
};
